module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_7016.b7a8bdd1.png";